import { Input } from "@clipboard-health/ui-components";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { usePostComment } from "@src/appV2/redesign/Workplace/Review/api/usePostComment";
import { getWorkplaceCommentsQueryKey } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import { useUpdateCachedComment } from "./useUpdateCachedComment";

interface WorkplaceCommentPostReplyFooterProps {
  workplaceId: string;
  parentId: string;
}

export function WorkplaceCommentPostReplyFooter(props: WorkplaceCommentPostReplyFooterProps) {
  const { workplaceId, parentId } = props;

  const [text, setText] = useState("");

  const queryClient = useQueryClient();

  const { updateComment: updatePaginatedCommentList } = useUpdateCachedComment({
    workplaceId,
    commentsParams: { workplaceId, page: { size: 200 } },
  });

  const { mutate: postComment, isLoading: isPostingComment } = usePostComment(workplaceId, {
    onSuccess: async (data) => {
      setText("");

      // refetch the replies of the parent comment
      await queryClient.invalidateQueries({
        queryKey: getWorkplaceCommentsQueryKey({
          workplaceId,
          filter: { parentCommentId: parentId },
        }),
      });

      const parentComment = data.data.relationships.parentComment?.data;

      if (parentComment) {
        updatePaginatedCommentList(parentComment);
      }
    },
  });

  return (
    <DialogFooter withShadow orientation="horizontal">
      <Input
        placeholder="Post a comment..."
        value={text}
        onChange={(event) => {
          setText(event.target.value);
        }}
      />
      <IconButton
        iconType="arrow-up"
        variant="contained"
        disabled={!text || isPostingComment}
        onClick={() => {
          postComment({ text, parentId });
        }}
      />
    </DialogFooter>
  );
}
